export default function MySQL_DATEDIFF() {
  return (
    <div>
      <h2>MySQL_DATEDIFF</h2>    </div>
  );
}